import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Download, Clock, Shield, Smartphone } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: <Download className="w-5 h-5" data-id="element-157" />,
    text: 'Descarga inmediata'
  }, {
    icon: <Clock className="w-5 h-5" data-id="element-158" />,
    text: 'Léelo en 90min'
  }, {
    icon: <Shield className="w-5 h-5" data-id="element-159" />,
    text: 'Garantía 7 días'
  }, {
    icon: <Smartphone className="w-5 h-5" data-id="element-160" />,
    text: 'Compatible con móvil'
  }];
  return <section className="relative pt-12 pb-20 md:pt-16 md:pb-28 px-6 overflow-hidden" data-id="element-161">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-cream rounded-full blur-3xl opacity-50 -z-10" data-id="element-162" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-163">
        {/* Tag */}
        <FadeIn data-id="element-164">
          <span className="inline-block py-2 px-4 rounded-full bg-brand-sage-light text-brand-sage font-medium text-xs md:text-sm mb-8 tracking-wide uppercase" data-id="element-165">
            📖 Guía táctica para madres y padres de niños de 2 a 7 años
          </span>
        </FadeIn>

        {/* Headline */}
        <FadeIn delay={0.1} data-id="element-166">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-brand-charcoal" data-id="element-167">
            Cómo detener un berrinche en{' '}
            <span className="text-brand-orange italic" data-id="element-168">180 segundos</span>
            <br data-id="element-169" />
            sin gritar, sin amenazas y sin perder los nervios
          </h1>
        </FadeIn>

        {/* Subheadline */}
        <FadeIn delay={0.2} data-id="element-170">
          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-171">
            El protocolo paso a paso para madres y padres que ya están cansados
            de improvisar cada vez que todo explota
          </p>
        </FadeIn>

        {/* Cover Image */}
        <FadeIn delay={0.3} data-id="element-172">
          <div className="mb-10 flex justify-center" data-id="element-173">
            <motion.div className="relative w-64 md:w-80 lg:w-96" animate={{
            y: [0, -10, 0],
            rotateZ: [-0.5, 0.5, -0.5]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-174">
              <motion.div className="absolute -inset-6 bg-brand-orange/10 rounded-3xl blur-2xl -z-10" animate={{
              scale: [1, 1.05, 1],
              opacity: [0.5, 0.8, 0.5]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-175" />
              <img src="https://cdn.magicpatterns.com/uploads/s18vRXAFSfRD9B13kwD45A/portada_2.png" alt="Protocolo Calma 3 Minutos — Portada" className="w-full h-auto rounded-2xl shadow-2xl border border-gray-100" data-id="element-176" />
            </motion.div>
          </div>
        </FadeIn>

        {/* Trust Badges */}
        <FadeIn delay={0.4} data-id="element-177">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10 max-w-3xl mx-auto" data-id="element-178">
            {badges.map((badge, index) => <div key={index} className="flex flex-col items-center gap-2 p-4 bg-white rounded-xl border border-gray-100" data-id="element-179">
                <div className="text-brand-orange" data-id="element-180">{badge.icon}</div>
                <span className="text-sm font-medium text-gray-700 text-center" data-id="element-181">
                  {badge.text}
                </span>
              </div>)}
          </div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.5} data-id="element-182">
          <div className="flex flex-col items-center gap-4" data-id="element-183">
            <Button onClick={scrollToPricing} data-id="element-184">
              👉 SÍ QUIERO EL PROTOCOLO AHORA
            </Button>
            <p className="text-sm text-gray-500" data-id="element-185">
              Acceso inmediato por solo $9.99
            </p>
            <p className="text-xs text-gray-400 flex items-center gap-1" data-id="element-186">
              🔒 Pago seguro • 📥 PDF instantáneo • Sin suscripciones
            </p>
          </div>
        </FadeIn>

        {/* Social Proof */}
        <FadeIn delay={0.6} data-id="element-187">
          <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-188">
            <p className="text-brand-orange font-medium" data-id="element-189">
              ⭐⭐⭐⭐⭐{' '}
              <span className="text-gray-700" data-id="element-190">
                +847 familias ya lo están usando
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}